'use strict';

module.exports = require( 'ck-core/source/functions/makeLang' )( {
	TITLE: 'Choose your coding plan',
	SUBTITLE: 'Learn to code Minecraft & Roblox at your own pace online',
	UPGRADE: {
		TITLE: 'Get more out of Code Kingdoms',
		SUBTITLE: 'Upgrade or extend your membership today!'
	},
	BOTTOM_INFO: "Not sure which plan to buy? Don't worry - you can upgrade at any time.",
	NO_PLANS_AVAILABLE: 'Sorry, there are no plans of this type available for you because you have already bought this product.',
	GIFT: {
		HEADER: 'Looking for a gift?',
		COPY: `No problem! You can send your gift after purchasing. We'll even extend our refund period to 30 days past redeeming.`
	},
	HOMESCHOOLING: {
		HEADER: 'No school? No worries',
		COPY: "We've made it easy to learn coding at home whether for homeschooling or just for fun"
	},
	HOMESCHOOLING_PROMO: {
		HEADER: 'Learn Coding at Home',
		COPY: "We've temporarily reduced our prices so more young people can have fun learning to code at home"
	},
	BLACKFRIDAY_PROMO: {
		HEADER: 'Black Friday comes early',
		COPY: "Every year we offer our biggest sale on Black Friday weekend. This leads to a surge in questions for our team. So this year, we have decided to  launch the same sale prices early so we can better and more promptly answer any queries you may have."
	},
	MEMBERSHIP: {
		TITLE: 'All Memberships Include',
		CHECKLIST: [ {
				NAME: "1",
				DESCRIPTION: "Interactive video courses"
			},
			{
				NAME: "2",
				DESCRIPTION: "Private server"
			},
			{
				NAME: "3",
				DESCRIPTION: "Automatic skills assessment"
			},
			{
				NAME: "4",
				DESCRIPTION: "Unlimited access & free updates"
			},
			{
				NAME: "5",
				DESCRIPTION: "Beginner-friendly code editor"
			},
			{
				NAME: "6",
				DESCRIPTION: "7 days a week online support"
			}
		]
	}
} );
